<template>
  <div class="grid-cols-12 gap-x-8 gap-y-2 flex-wrap whitespace-no-wrap" :class="[flex ? 'flex' : 'grid', mobileView? 'mobileView': '']">
    <label v-for="item in items" :key="`RadioGroup-${id}-${getLabel(item)}`"
           class="flex gap-2"
           :class="[noneRow ? '' : 'col-span-' + Math.ceil(12 / setRowCount), selectItem === item ? 'active' : '']"
           :style="mobileView
                   ? {color: selectItem === item ? activeColor[item].color : '',
                       backgroundColor: selectItem === item ? activeColor[item].background : ''}
                   : {}"
    >
      <div class="radio-group-list-print">
        <PrintRadio :value="selectItem === item" :label="getLabel(item)"/>
        <slot v-if="selectItem === item" :name="item" />
      </div>
      <div class="radio-group-list">
        <vs-radio :vs-value="getValue(item)" :vs-name="id" :disabled="readonly" v-model="selectItem">{{ getLabel(item) }}</vs-radio>
        <slot v-if="selectItem === item" :name="item" />
      </div>
    </label>
  </div>
</template>
<script>
import PrintRadio from "@/components/print/PrintRadio.vue";

export default {
  name: "RadioGroup",
  components: {PrintRadio},
  props: {
    value: [String, Number, Boolean],
    items: Array,
    activeColor: Object,
    // col-span을 사용하지 않음
    noneRow: { type: Boolean, default: false },
    /** 한 줄에 표시할 셀의 개수 (1 ~ 4) */
    rowCount: { type: Number, default: 2 },
    flex: Boolean,
    mobileView: Boolean, // 모바일 형식 뷰
    readonly: Boolean,
  },
  computed: {
    selectItem: {
      get() {
        return this.value;
      },
      set(value) {
        if (this.value !== value) {
          this.$emit("input", value);
        }
      },
    },

    setRowCount() {
      if (4 < this.rowCount) return 4;
      else if (this.rowCount < 1) return 1;
      else return this.rowCount;
    },
  },
  data() {
    return {
      id: Math.random().toString(36).substr(2, 9),
    };
  },
  methods: {
    getLabel(item) {
      if (typeof item === "object") {
        return item.label;
      }
      return item;
    },
    getValue(item) {
      if (typeof item === "object") {
        return item.value;
      }
      return item;
    },
  },
};
</script>

<style scoped lang="scss">
.radio-group-list-print {
  display: none;
}
.radio-group-list {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

@media print {
  .radio-group-list {
    display: none;
  }

  .radio-group-list-print {
    display: block;
  }
}

.mobileView {
  display: flex;
  border: 1px solid #CDCDCD;
  border-radius: 8px;
  padding: 0;
  gap:0 !important;
  & > label {
    flex: 1;
    padding: 10px;
    border-right: 1px solid #CDCDCD;
    display: flex;
    justify-content: center;
    cursor: pointer;

    &:first-child {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
    &:last-child {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      border-right: none;
    }
    &.active {
      background-color: #28C76F;
      color: white;
    }
    &::v-deep(.vs-radio) {
      display: none;
    }
  }
}

</style>
